import { useEffect } from 'react';
import useDrawerInfo from '@components/EntityDrawers/hooks/useDrawerIfo';
import { ProjectDrawerTypes } from '@constants/entities/drawers';
import { useProject } from '@context/Project/ProjectProvider';

/**
 * Whether a drawer of `type` is the open one, for components that mount their
 * body only while open.
 *
 * Owns the closed half of the unsaved-changes contract: a drawer that is not
 * rendered cannot clear the flag itself, and `useProjectDrawerChanges` inside
 * the body only runs while the body exists.
 */
const useDrawerGate = (
  type: ProjectDrawerTypes,
  editType: ProjectDrawerTypes,
) => {
  const { open } = useDrawerInfo({ type, editType });
  const { setHasChanges } = useProject();

  useEffect(() => {
    if (!open) setHasChanges(false);
  }, [open]);

  return open;
};

export default useDrawerGate;
